<template lang="pug">
    include CorrectPassword.pug
</template>

<script>
import Api from '@/components/services/Api';

export default {
    name: 'CorrectPassword',
    data() {
        return {
            password1: "",
            password2: "",
            message: "",
        };
    },
    computed: {
        valid() {
            if (!this.password1.length || !this.password2.length) return false;
            if (this.password1 != this.password2) return false;
            return true;
        }
    },
    methods: {
        perform() {
            const _this = this;
            const token = this.$route.params.uuid;

            Api.changePassword(token, this.password1).then(resp => {
                _this.password1 = "";
                _this.password2 = "";
                _this.message = "Se ha creado la contraseña correctamente";
            }).catch();
        }
    }
}

</script>

<style scoped lang="scss">
@import './../../variables';
@import "CorrectPassword";
</style>



// WEBPACK FOOTER //
// src/components/correct_password/CorrectPassword.vue